export default {
  mounted(el, binding) {
    let observer
    const options = {
      rootMargin: '0px',
      threshold: 0.1
    }

    observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (el.tagName === 'IMG') {
            el.src = binding.value
          } else if (el.tagName === 'VIDEO') {
            el.src = binding.value
            el.load() // 加载视频
          }
          observerInstance.unobserve(el)
        }
      })
    }, options)

    observer.observe(el)
  }
}
